import { useEffect, useRef } from 'react';

import { actionEmitter } from '../websocket/actionEmitter';

export function useReduxAction<A>(actionType: string, callback: (action: A) => void): void {
  const cbRef = useRef(callback);
  cbRef.current = callback;

  useEffect(() => {
    return actionEmitter.on(actionType, (action) => cbRef.current(action as A));
  }, [actionType]);
}
